
import * as React from "react";
import {Api} from "../../../../lib/Api";
import $ from "jquery";

interface ICancelButtonProps {
    order: any
    setUrl: any
}

interface ICancelButtonState {
    openModal: boolean
    message: string
}

export default class CancelButton extends React.Component<ICancelButtonProps, ICancelButtonState>{

    constructor(props:ICancelButtonProps){
        super(props);
        this.state = {
            openModal: false,
            message: ''
        };


    }

    private cancelOrder() {
        Api.call('/user/order/cancelOrder', {
            orderId: this.props.order.id,
            message: this.state.message
        }, (result) =>{
            $('#cancel_order_modal').modal('toggle');
            if ( document.querySelector('.modal-backdrop') !== null ) {
                $('.modal-backdrop').remove();
            }

            this.props.setUrl('/user/index');
        });
    }


    render() {

        const statuses = ['cancelled', 'completed'];
        if(statuses.includes(this.props.order.status.key)){
            return (<></>);
        }

        if(this.state.openModal) {
            setTimeout(() => {
                if ( document.querySelector('#cancel_order_modal') !== null ) {
                    $('#cancel_order_modal').modal({show:true});
                }

            }, 200);
        }

        let order = this.props.order;
        return (
            <>
                <div className = "row">
                    <div className = "col-md-12">
                        <button className="red_btn" onClick={() => this.setState({openModal: true})}>I cancel the order</button>
                    </div>
                </div>

                {
                    this.state.openModal &&
                    <div role="dialog" className="modal fade" id="cancel_order_modal">
                        <div className="modal-dialog modal-md" role="document">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <div className="modal_content edit-offer-box edit-order-box">

                                        <div className="form-row">
                                            <div className="col text-center">
                                                <h1>
                                                    Why are you canceling the order?
                                                </h1>
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div className="col sfc">
                                                <textarea className="s-form-control" rows={8} onChange={ (e) => this.setState({message: e.target.value}) } placeholder="your message"></textarea>
                                            </div>
                                        </div>

                                        <button className = "purple_btn" onClick={() => this.cancelOrder()}>Send</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                }
            </>

        );
    }
}
